import React, { PropTypes } from 'react';
import { replace } from 'react-router-redux';
import { connect } from 'react-redux';
import {
  createTextParagraph,
  updateTextParagraph,
} from 'tip/actions/paragraphs';
import ParagraphForm from 'tip/components/ParagraphForm';

const mapDispatchToProps = (dispatch, ownProps) => ({
  saveTextParagraph: fields => {
    const { params: { id: chapter, paragraph } } = ownProps;
    if (chapter) {
      dispatch(createTextParagraph(chapter, fields));
    } else {
      dispatch(updateTextParagraph(paragraph, fields));
    }

    // Redirecting to chapters
    dispatch(replace('/'));
  },
});

const ParagraphPage = ({ saveTextParagraph, params: { paragraph } }) => (
  <ParagraphForm onSubmit={saveTextParagraph} id={paragraph} />
);

ParagraphPage.propTypes = {
  params: PropTypes.object.isRequired,
  saveTextParagraph: PropTypes.func.isRequired,
};

export default connect(state => state, mapDispatchToProps)(ParagraphPage);



// WEBPACK FOOTER //
// ./src/modules/tip/pages/ParagraphPage.js